export default __webpack_public_path__ + "static/media/cover-vigevano.44b3005f.png";